import { SearchX } from "lucide-react";

export const EmptyState = () => (
  <div className="flex flex-col items-center justify-center py-20 text-brand-muted gap-3">
    <SearchX size={48} strokeWidth={1} />
    <p className="text-lg font-medium">No applicants found</p>
    <p className="text-sm">Try adjusting your search or filters</p>
  </div>
);